import {Injectable} from '@angular/core';
import {HttpModelConverter} from "../../../../core/converter/httpModel.converter";
import {InsoleMaterialModel} from "./insoleMaterial.model";
import {InsoleMaterialSummaryConverter} from "./insoleMaterialSummary.converter";
@Injectable({
    providedIn: 'root'
})
export class InsoleMaterialConverter extends HttpModelConverter<InsoleMaterialModel> {

    constructor(private summaryConverter: InsoleMaterialSummaryConverter) {
        super();
    }

    protected createInstance(): InsoleMaterialModel {
        return new InsoleMaterialModel();
    }

    protected enrichObject(result: InsoleMaterialModel, src: InsoleMaterialModel) {
        result.summary = this.summaryConverter.convert(src.summary);
        result.parent = this.summaryConverter.convert(src.parent);
    }

}
